import React from 'react';
import { ContactPageLayout } from '@Features/ContactPage';

const ContactPage: React.FC = () => {
  return <ContactPageLayout />;
};

export default ContactPage;
